import {PLAYERSTATUS} from "@/constants";

export const gPlayer: HTMLAudioElement = document.createElement('audio');
gPlayer.src = "data:audio/wav;";
export const gAudioContext: AudioContext = new AudioContext();
if(gAudioContext) {
    const resumeAudioContext = () => {
        gAudioContext.resume();
    };
    gPlayer.addEventListener('play', resumeAudioContext);
}
export const gAnalyser: AnalyserNode = gAudioContext.createAnalyser();
const source = gAudioContext.createMediaElementSource(gPlayer);
source.connect(gAnalyser);
gAnalyser.connect(gAudioContext.destination);

export const gBufferLength = gAnalyser.fftSize;

export const initializePlayer = (options: IInitializePlayer) => {
    const setPlayerPlaying = () => {
        options.setPlayerStatus(PLAYERSTATUS.PLAYING);
    }
    const setPlayerLoading = () => {
        options.setPlayerStatus(PLAYERSTATUS.LOADING);
    }
    gPlayer.addEventListener('playing', setPlayerPlaying);
    gPlayer.addEventListener('waiting', setPlayerLoading);

    return () => {
        gPlayer.removeEventListener('playing', setPlayerPlaying);
        gPlayer.removeEventListener('waiting', setPlayerLoading);
    };
}

export const setFile = (options: ISetFile) => {
    const newSrc = options.file?.fileSrc as string;
    if(encodeURI(newSrc) !== gPlayer.src) {
        gPlayer.src = newSrc || "data:audio/wav;";
        gPlayer.crossOrigin = "anonymous";
        gPlayer.load();
        options.setCurrentTime("00:00");
        options.setTotalTime("00:00");
        options.setPlayerStatus(PLAYERSTATUS.LOADING);
    }
}

export const listenTimeUpdateEvent = (options: IListenTimeUpdateEvent) => {
    const timeUpdate = (e: any) => {
        const pl = e.target as HTMLAudioElement;
        if(pl.duration) {
            options.setCurrentTime(new Date(pl.currentTime * 1000).toISOString().substring(14, 19));
            options.setTotalTime(new Date(pl.duration * 1000).toISOString().substring(14, 19));
            if(pl.duration === pl.currentTime && options.playerStatus !== PLAYERSTATUS.TEMP_PAUSE) {
                options.setPlayerStatus(PLAYERSTATUS.REPEAT);
            }
        }
    }
    gPlayer.addEventListener('timeupdate', timeUpdate);

    return () => {
        gPlayer.removeEventListener('timeupdate', timeUpdate);
    };
}


export const playerStatusChanged: (options: IPlayerStatusChangedProps) => void = (options) => {
    try {
        if(options.playerStatus === PLAYERSTATUS.PLAYING || options.playerStatus === PLAYERSTATUS.LOADING) gPlayer.play();
        else gPlayer.pause();    
    } catch(e) {}

    if(options.playerStatus === PLAYERSTATUS.PLAYING) {
        const danceInterval = setInterval(() => {
            const da = new Float32Array(gBufferLength);
            gAnalyser.getFloatTimeDomainData(da);
            options.setDataArray(da);
        }, 60);

        return () => {
            clearInterval(danceInterval);
        };
    } else options.setDataArray(new Float32Array(gBufferLength));
}

export const dataArrayChanged = (options: IDataArrayChangedProps) => {
    if(options.dataArray && options.playerStatus === PLAYERSTATUS.PLAYING) {
        let sum = 0;
        options.dataArray.forEach(d => sum += Math.abs(d));
        options.setBgColor('hsla(' + sum + ', 100%, 50%)');
    } else {
        options.setBgColor('var(--bs-primary)');
    }
}

export const forward = (player: HTMLAudioElement | undefined) => {
    return () => (player || {currentTime: 0}).currentTime += 10;
};

export const backward = (player: HTMLAudioElement | undefined) => {
    return () => (player || {currentTime: 0}).currentTime -= 10;
};